function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { Fill, Stroke, Text, Icon } from 'ol/style';
import Style from 'ol/style/Style';
import { DEFAULT_ICON_ANCHOR_POSITION, DEFAULT_TEXT_ALIGN, DEFAULT_TEXT_ROTATION_ANGLE, LABEL_FILL_COLOR_KEY, LABEL_FONT_KEY, LABEL_ROTATION_KEY, LABEL_STROKE_COLOR_KEY, LABEL_STROKE_WIDTH_KEY, LABEL_TEXT_ALIGN_KEY, LABEL_TEXT_KEY } from './constants';
export var degreesToRadian = angleDegrees => {
  return angleDegrees ? angleDegrees * (Math.PI / 180) : DEFAULT_TEXT_ROTATION_ANGLE;
};

var mapLabelStyleOptions = styleOptions => {
  var _icon$position, _icon$scale;

  var {
    text,
    icon,
    textLabel,
    rotation
  } = styleOptions;
  var {
    fill,
    font,
    textAlign,
    stroke
  } = text;
  return new Style(_objectSpread({
    text: new Text(_objectSpread({
      fill: new Fill({
        color: fill.color
      }),
      font,
      textAlign: textAlign !== null && textAlign !== void 0 ? textAlign : DEFAULT_TEXT_ALIGN,
      text: textLabel,
      rotation
    }, stroke && {
      stroke: new Stroke({
        color: stroke === null || stroke === void 0 ? void 0 : stroke.color,
        width: stroke === null || stroke === void 0 ? void 0 : stroke.width
      })
    }))
  }, icon.iconSrc && {
    image: new Icon({
      anchor: (_icon$position = icon.position) !== null && _icon$position !== void 0 ? _icon$position : DEFAULT_ICON_ANCHOR_POSITION,
      anchorXUnits: 'fraction',
      anchorYUnits: 'pixels',
      src: icon.iconSrc,
      scale: (_icon$scale = icon.scale) !== null && _icon$scale !== void 0 ? _icon$scale : 1,
      rotation: icon.rotation
    })
  }));
};

export var getLabelStyle = (feature, styleOptions) => {
  var textLabel = feature.get(LABEL_TEXT_KEY);
  var textLabelRotation = degreesToRadian(feature.get(LABEL_ROTATION_KEY));

  if (styleOptions) {
    return mapLabelStyleOptions(_objectSpread(_objectSpread({}, styleOptions), {}, {
      textLabel,
      rotation: textLabelRotation
    }));
  } else {
    var returnStrokeStyles = !!(feature.get(LABEL_FONT_KEY) && feature.get(LABEL_STROKE_WIDTH_KEY));
    var styleOptionsFromFeatureProps = {
      textLabel,
      rotation: textLabelRotation,
      text: _objectSpread({
        fill: {
          color: feature.get(LABEL_FILL_COLOR_KEY)
        },
        font: feature.get(LABEL_FONT_KEY),
        textAlign: feature.get(LABEL_TEXT_ALIGN_KEY)
      }, returnStrokeStyles && {
        stroke: {
          color: feature.get(LABEL_STROKE_COLOR_KEY),
          width: feature.get(LABEL_STROKE_WIDTH_KEY)
        }
      }),
      icon: {}
    };
    return mapLabelStyleOptions(styleOptionsFromFeatureProps);
  }
};